export default __webpack_public_path__ + "static/media/info-red.99fa152c.svg";